//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { Component, OnInit } from '@angular/core';
import { InactivityTimerService } from '@app/core/services/inactivity-timer.service';
import { SharedMemberResponseService } from '@app/member-response-portal/service/shared-member-response.service';
//#endregion Imports
@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
    //#region Public Variables
    public ReferenceNumber: string = null;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(
        private authenticationService: AuthenticationService,
        private inactivityTimerService: InactivityTimerService,
        private sharedMemberResponseService: SharedMemberResponseService) { }

    public ngOnInit(): void {
        this.ReferenceNumber = this.sharedMemberResponseService.GetReferenceNumber();
        this.inactivityTimerService.StopInactivityTimerService();
        this.authenticationService.Logout();
    }
    //#endregion Constructor

    //#region Public Methods
    public OnClickRedirectToLogin(): void {
        this.authenticationService.RedirectToLogin();
    }
    //#endregion Public Methods

    //#region Private Methods
    //#region Private Methods
}
